/**
 * 管理端点餐提醒：WebSocket 实时通道（不受标签页节流影响）
 */
import store from '@/store'

let ws = null
let reconnectTimer = null
let reconnectAttempt = 0
let stopped = true
let onAlertCallback = null

function buildWsUrl() {
  const apiBase = (process.env.VUE_APP_BASEURL || '').trim()
  let host = ''
  try {
    const u = new URL(apiBase, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    host = u.host
  } catch (e) {
    if (typeof window !== 'undefined') {
      host = window.location.host
    }
  }
  const isSecure =
    apiBase.startsWith('https:') ||
    (typeof window !== 'undefined' && window.location.protocol === 'https:')
  const token = encodeURIComponent(store.getters.token || 'merchant-admin')
  return `${isSecure ? 'wss' : 'ws'}://${host}/ws?token=${token}`
}

function scheduleReconnect() {
  if (stopped || reconnectTimer) return
  const delay = Math.min(30000, 2000 * 2 ** reconnectAttempt)
  reconnectAttempt += 1
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null
    connectMerchantAlertWs(onAlertCallback)
  }, delay)
}

function handleMessage(event) {
  let payload
  try {
    payload = JSON.parse(event.data)
  } catch (e) {
    return
  }
  if (!payload || payload.type !== 'merchant_food_alert') return
  const data = payload.data || {}
  const alertType = data.alertType
  const orderId = data.orderId != null ? String(data.orderId) : ''
  if (!alertType || typeof onAlertCallback !== 'function') return
  onAlertCallback(alertType, orderId)
}

export function connectMerchantAlertWs(onAlert) {
  if (typeof WebSocket === 'undefined') return
  onAlertCallback = onAlert
  stopped = false

  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return
  }

  try {
    ws = new WebSocket(buildWsUrl())
  } catch (e) {
    scheduleReconnect()
    return
  }

  ws.onopen = () => {
    reconnectAttempt = 0
  }

  ws.onmessage = handleMessage

  ws.onerror = () => {
    /* onclose 会处理重连 */
  }

  ws.onclose = () => {
    ws = null
    if (!stopped) scheduleReconnect()
  }
}

export function disconnectMerchantAlertWs() {
  stopped = true
  onAlertCallback = null
  if (reconnectTimer) {
    clearTimeout(reconnectTimer)
    reconnectTimer = null
  }
  reconnectAttempt = 0
  if (ws) {
    try {
      ws.onclose = null
      ws.close()
    } catch (e) {
      /* ignore */
    }
    ws = null
  }
}

export function isMerchantAlertWsConnected() {
  return ws != null && ws.readyState === WebSocket.OPEN
}
